import {
    FETCH_VEHICLES_REQUEST,
    FETCH_VEHICLES_SUCCESS,
    FETCH_VEHICLES_FAILURE,
    UPDATE_VEHICLE_STATUS_REQUEST,
    UPDATE_VEHICLE_STATUS_SUCCESS,
    UPDATE_VEHICLE_STATUS_FAILURE,
  } from "./types";
  
  import { fetchAllVehicles, updateVehicleStatus } from "../../services/vehicleService";
  
  // Action Creators
  export const fetchVehiclesRequest = () => ({ type: FETCH_VEHICLES_REQUEST });
  
  export const fetchVehiclesSuccess = (vehiclesData) => ({
    type: FETCH_VEHICLES_SUCCESS,
    payload: vehiclesData,
  });
  
  export const fetchVehiclesFailure = (error) => ({
    type: FETCH_VEHICLES_FAILURE,
    payload: error,
  });
  
  // Action Creators
export const updateVehicleStatusRequest = () => ({
  type: UPDATE_VEHICLE_STATUS_REQUEST,
});

export const updateVehicleStatusSuccess = (updatedVehicle) => ({
  type: UPDATE_VEHICLE_STATUS_SUCCESS,
  payload: updatedVehicle,
});

export const updateVehicleStatusFailure = (error) => ({
  type: UPDATE_VEHICLE_STATUS_FAILURE,
  payload: error,
});

  // Thunk to fetch vehicles
  export const fetchVehiclesAction = () => async (dispatch) => {
    dispatch(fetchVehiclesRequest());
  
    try {
      const response = await fetchAllVehicles();
  
      if (response.error) {
        dispatch(fetchVehiclesFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(fetchVehiclesSuccess(response.data));
        return { success: true, data: response.data };
      }
    } catch (error) {
      dispatch(fetchVehiclesFailure(error.message || "Failed to fetch vehicles"));
      return { success: false, error: error.message || "Failed to fetch vehicles" };
    }
  };
  

export const updateVehicleStatusAction = (vehicleId, newStatus, statusReason = null) => async (dispatch) => {
  dispatch(updateVehicleStatusRequest());

  try {
    const response = await updateVehicleStatus(vehicleId, newStatus, statusReason);

    if (response.success) {
      dispatch(updateVehicleStatusSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      dispatch(updateVehicleStatusFailure(response.error));
      return { success: false, error: response.error };
    }
  } catch (error) {
    const errMsg = error.message || "Failed to update vehicle status";
    dispatch(updateVehicleStatusFailure(errMsg));
    return { success: false, error: errMsg };
  }
};
